export default {
  GETTERS: {
    GET_PRODUCT: 'MEGAPHONE/GET_PRODUCT',
    GET_MODAL_PARAMS: 'MEGAPHONE/GET_MODAL_PARAMS',
    GET_POSITION_RATE: 'MEGAPHONE/GET_POSITION_RATE',
    GET_CAN_BOOST: 'MEGAPHONE/GET_CAN_BOOST',
    GET_MODAL_IS_OPENED: 'MEGAPHONE/GET_MODAL_IS_OPENED',
    GET_BOOST_ACTION_ERROR: 'MEGAPHONE/GET_BOOST_ACTION_ERROR',
    GET_STATS: 'MEGAPHONE/GET_STATS'
  },
  MUTATIONS: {
    SET_PRODUCTS: 'MEGAPHONE/SET_PRODUCTS',
    SET_MESSAGES: 'MEGAPHONE/SET_MESSAGES',
    SET_PRODUCT_TO_BOOST: 'MEGAPHONE/SET_PRODUCT_TO_BOOST',
    UPDATE_PRODUCT: 'MEGAPHONE/UPDATE_PRODUCT',
    SET_MODAL_PARAMS: 'MEGAPHONE/SET_MODAL_PARAMS',
    SET_MODAL_IS_OPENED: 'MEGAPHONE/SET_MODAL_IS_OPENED',
    SET_BOOST_ACTION_ERROR: 'MEGAPHONE/SET_BOOST_ACTION_ERROR',
    SET_STATS: 'MEGAPHONE/SET_STATS'
  },
  ACTIONS: {
    LOAD: 'MEGAPHONE/LOAD',
    BOOST: 'MEGAPHONE/BOOST',
    SHOW_METRICS: 'MEGAPHONE/SHOW_METRICS',
    LOAD_STATS: 'MEGAPHONE/LOAD_STATS'
  }
}
